import _ from "lodash";

export const entity = {
    name: 'Company',
    facets: [{name: 'codeName', uniqueName: true}, {name: 'conversations'}],
    fields: [
        { type: 'Unit', nullable: true },
        {type: 'SectorOfActivity', nullable: true},
        'Scope',
        {path: 'revenue', type: 'integer', nullable: true},
        'description',
        {path: 'status', type: 'CompanyStatus', nullable: true},
        {path: 'state', type: 'Status'}
    ],
    filters: [
        {
            name: 'byStatus',
            path: "status",
            object: "Status",
            display: 'name',
            isDefault: false,
            client: true,
            query: function(context) {
                const status = _.get(context, 'data.status.id');
                return status ? {status: status} : {};
            }
        }
    ]
}

export const module_ = {
    object: 'Company',
    category: {
        path: 'referential',
        icon: 'server'
    },
    defaultSortBy: 'code',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            { path: 'unit', tKey: 'group', initiallyNotVisible: true },
            'code',
            'name',
            'sectorOfActivity',
            'scope',
            {path: 'revenue', tKey: 'revK€'},
            {path: 'status'},
            'state'
        ],
        form: [
            { path: 'unit', tKey: 'group', display: 'fullName'},
            {path: 'code', placeholder: 'renseigner un code unique', noSpaces: true},
            {path: 'name', placeholder: 'renseigner un nom unique'},
            {path: 'sectorOfActivity', display: 'fullName', placeholder : 'Sélectionner le secteur d’activité de la société'},
            {path: 'scope', placeholder : 'Sélectionner la couverture géographique de la société'},
            {path: 'revenue', minValue: 0, tKey: 'revK€'},
            { path: 'description', tKey: 'synthèse', type: 'richTextEditor', placeholder : 'Saisir les raisons du choix de la société (Plus, moins, opportunités, risques, etc.)' },
            {path: 'status', placeholder : 'Sélectionner le statut de la société'},
            {path: 'conversations', tKey: 'suivi'},
            {path: 'state', type: 'toggle', default: {id: 'actif'}}
        ]
    },
    filters: [
        {
            tKey: 'group',
            path: 'unit',
            object: 'Unit',
            display: 'fullName',
            client: true,
            clearable: true,
            placeholder: 'selectGroup',
            default: {id: null},
            query: function(context) {
                const unitId = _.get(context.data, 'unit.id')
                if (unitId)
                    return { unit: new global.ObjectID(unitId) }
                return {}
            }
        },
        'byStatus'
    ]
}
